import { StyleSheet, View } from "@react-pdf/renderer";
import { tableStyles } from "./SmartTitanProjektPDF";
import { DataTableHeader } from "./DataTableHeader";
import { DataTableFooter } from "./DataTableFooter";
import { DataTableDataRow } from "./DataTableDataRow";

export function DataTable({ item, tableInput, tableCalculated, sumRsdi, lreq }) {
  return (
    <View style={tableStyles.tableContainer}>
      {/* TableHeader */}

      <DataTableHeader item={item} />

      {tableInput.map((row, index) => {
        return (
          <DataTableDataRow
            item={item}
            key={index}
            index={index}
            tableInput={tableInput}
            tableCalculated={tableCalculated}
          />
        );
      })}

      {/* Table footer */}
      <DataTableFooter item={item} sumRsdi={sumRsdi} lreq={lreq} />
    </View>
  );
}

export const tableDataTableStyles = StyleSheet.create({
  // Data and footer rows render in normal weight; only the header (headerRow*)
  // stays bold, so the soil-layer table reads as a classic table instead of
  // being printed entirely in bold.
  row: {
    flexDirection: "row",
    alignItems: "center",
    height: 24,
  },

  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    height: 14,
    fontWeight: "bold",
  },

  headerRow_Table: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    fontWeight: "bold",
  },

  headerRowBottom: {
    flexDirection: "row",
    alignItems: "center",
    height: 14,
    fontWeight: "bold",
    borderBottomColor: "#000",
    borderBottomWidth: 0.3,
  },

  title: {
    width: "14.1%",
    textAlign: "left",
    paddingLeft: 8,
  },

  title_fhwa: {
    width: "11.1%",
    textAlign: "left",
    paddingLeft: 8,
  },

  bez: {
    width: "10%",
    textAlign: "right",
    alignContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 8,
  },
  bezimage: {
    width: "20pt",
    height: "8pt",
  },

  unit: {
    width: "10%",
    textAlign: "left",
  },
  value: {
    width: "10%",
    textAlign: "center",
  },
  formula: {
    width: "20%",
    textAlign: "left",
  },
  formulaimage: {
    height: 7,
    textAlign: "left",
    paddingRight: 10,
  },
});
